import { atom } from "jotai";
import type { ComponentColor } from "@common/types";

export const notificationsAtom = atom<Notification[]>([]);

export const addNotificationAtom = atom(
    null,
    (get, set, notification: Omit<Notification, "id" | "timestamp">) => {
        const newNotification: Notification = {
            ...notification,
            id: `notification-${Date.now()}-${Math.random()}`,
            timestamp: Date.now(),
            position: notification.position || "top-center",
            interval: notification.interval ?? null,
        };
        set(notificationsAtom, [...get(notificationsAtom), newNotification]);
    },
);

export const removeNotificationAtom = atom(
    null,
    (get, set, notificationId: string) => {
        set(
            notificationsAtom,
            get(notificationsAtom).filter(
                (notification) => notification.id !== notificationId,
            ),
        );
    },
);

export const clearNotificationsAtom = atom(null, (_get, set) => {
    set(notificationsAtom, []);
});

export interface Notification {
    id: string;
    message: string;
    title?: string;
    color: Extract<ComponentColor, "info" | "success" | "error" | "warning">;
    position?: NotificatonPosition;
    status?: number;
    timestamp: number;
    interval?: number | null;
}

export type NotificatonPosition =
    | "top-start"
    | "top-center"
    | "top-end"
    | "bottom-start"
    | "bottom-center"
    | "bottom-end";